import React from 'react';

import PropTypes from 'prop-types';
import {
    Button,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

function FormDialog(props) {
    const {
        cancelButtonText = 'Cancel',
        submitButtonText = 'Submit',

        dialogTitle = 'Title',
        dialogSubHeading = 'Subheading',
        handleSubmit,
        handleClose,
        isOpen,
        children,
    } = props;

    return (
        <Dialog open={isOpen} onClose={handleClose}>
            <DialogTitle>{dialogTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {dialogSubHeading}
                </DialogContentText>
                {(children)}
            </DialogContent>
            <DialogActions>
                {handleClose && <Button onClick={handleClose}>{cancelButtonText}</Button>}
                {handleSubmit && <Button variant='contained' onClick={handleSubmit}>{submitButtonText}</Button>}
            </DialogActions>
        </Dialog>
    );
}


FormDialog.propTypes = {
    cancelButtonText: PropTypes.string,
    submitButtonText: PropTypes.string,
    dialogTitle: PropTypes.string,
    dialogSubHeading: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
    isOpen: PropTypes.bool,
    children: PropTypes.any,
};

export default FormDialog;
